/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TextAlignRightIcon16Light } from './TextAlignRightIcon16Light';
import { TextAlignRightIcon16Regular } from './TextAlignRightIcon16Regular';
import { TextAlignRightIcon16Solid } from './TextAlignRightIcon16Solid';
import { TextAlignRightIcon20Light } from './TextAlignRightIcon20Light';
import { TextAlignRightIcon20Regular } from './TextAlignRightIcon20Regular';
import { TextAlignRightIcon20Solid } from './TextAlignRightIcon20Solid';
import { TextAlignRightIcon24Regular } from './TextAlignRightIcon24Regular';
import { TextAlignRightIcon24Solid } from './TextAlignRightIcon24Solid';
import { TextAlignRightIcon32Regular } from './TextAlignRightIcon32Regular';
import { TextAlignRightIcon64Regular } from './TextAlignRightIcon64Regular';
var sizes = {
    16: {
        light: TextAlignRightIcon16Light,
        regular: TextAlignRightIcon16Regular,
        solid: TextAlignRightIcon16Solid,
    },
    20: {
        light: TextAlignRightIcon20Light,
        regular: TextAlignRightIcon20Regular,
        solid: TextAlignRightIcon20Solid,
    },
    24: {
        regular: TextAlignRightIcon24Regular,
        solid: TextAlignRightIcon24Solid,
    },
    32: {
        regular: TextAlignRightIcon32Regular,
    },
    64: {
        regular: TextAlignRightIcon64Regular,
    },
};
export var TextAlignRightIcon = forwardRef('TextAlignRightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
